<template>
  <div class="bg-secondary basic-type" id="section-organizer">
    <div class="container-xl text-center text-primary">
      <div class="row">
        <div
          class="col-4 d-flex flex-column flex-md-row justify-content-evenly align-items-start align-items-md-center organizer"
        >
          <h2 class="mb-0">主辦單位</h2>
          <img src="@/assets/image/zerone logo(black).png" alt="zerone" />
        </div>
        <div
          class="col-4 d-flex flex-column flex-md-row justify-content-evenly align-items-start align-items-md-center organizer"
        >
          <h2 class="mb-0">協辦單位</h2>
          <img src="@/assets/image/digitimes logo.png" alt="digitimes" />
        </div>
        <div class="col-4"></div>
        <div
          class="col-4 mt-5 mb-4 d-flex flex-column flex-md-row justify-content-evenly cooperator"
        >
          <h2 class="text-start">合作夥伴</h2>
          <div class="place-holder"></div>
        </div>
        <div class="col-12">
          <div class="row">
            <div
              v-for="(logo, index) in cooperators"
              :key="index"
              class="cooperator-logo col-6 col-md-2 d-flex justify-content-center align-items-center mb-4"
            >
              <div><img :src="logo.url" alt="合作夥伴" class="w-100" /></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-row justify-content-center align-items-center mt-5"
      >
        <span class="fs-4 me-2">※</span>
        <p class="mb-0">
          以上依A-Z排列
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cooperators: [
        {
          url: new URL("@/assets/image/logo/logo1.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo37.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo2.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo4.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo5.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo6.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo7.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo8.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo9.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo10.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo11.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo12.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo13.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo14.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo15.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo16.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo17.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo18.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo19.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo20.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo21.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo22.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo23.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo24.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo25.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo26.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo27.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo28.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo29.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo39.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo30.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo31.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo32.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo40.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo33.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo34.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo35.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo38.png", import.meta.url).href,
        },
        {
          url: new URL("@/assets/image/logo/logo36.png", import.meta.url).href,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.organizer {
  img {
    width: 40%;
    object-fit: contain;
  }

  @media (max-width: $lg) {
    h2 {
      font-size: 1.5rem;
    }
  }

  @media (max-width: $md) {
    img {
      margin-left: 20px;
      margin-top: 20px;
      width: 75%;
    }

    h2 {
      font-size: 1.125rem;
    }
  }
}

.cooperator {
  .place-holder {
    width: 40%;
  }

  .cooperator-logo {
    height: 150px;

    img {
      object-fit: contain;
    }
  }

  @media (max-width: $lg) {
    h2 {
      font-size: 1.5rem;
    }
  }

  @media (max-width: $md) {
    h2 {
      font-size: 1.125rem;
    }
  }
}
</style>
